module.exports = __webpack_public_path__ + "img/1503254717.eddc548d.jpg";